var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contradiction"},[_c('span',[_vm._v("巨大的市场前景与行业壁垒之间的矛盾")]),_c('span',[_vm._v("是制约行业中小微企业“沉浸”行业的主要矛盾")])])
}]

export { render, staticRenderFns }